import React from 'react';
import { useDesignThinkingWhy } from '../../hooks/useDesignThinkingWhy';

interface DesignThinkingWhyProps {
  isActive: boolean;
}

const DesignThinkingWhy: React.FC<DesignThinkingWhyProps> = ({ isActive }) => {
  const { designThinkingWhy, loading, error } = useDesignThinkingWhy();

  const renderContent = () => {
    if (loading) {
      return (
        <div className="text-center py-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      );
    }

    if (error) {
      return (
        <div className="alert alert-warning" role="alert">
          Unable to load content from API. Error: {error}
        </div>
      );
    }

    // Check if API returned content
    const content = designThinkingWhy?.content;

    if (!content) {
      return (
        <div className="alert alert-info" role="alert">
          No content available from API.
        </div>
      );
    }

    return (
      <div className="blog-details__text" dangerouslySetInnerHTML={{ __html: content }} />
    );
  };

  return (
    <div className="dd-main-tab-panel dd-panel-why" style={{ display: isActive ? 'block' : 'none', maxWidth: '800px', margin: '0 auto' }}>
      <div className="blog-details__content" style={{ background: '#fff', borderRadius: '16px', boxShadow: '0 8px 28px -10px rgba(0,40,100,.12)', padding: '2rem' }}>
        {renderContent()}
      </div>
    </div>
  );
};

export default DesignThinkingWhy;

